import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { postJSON } from 'api/fetch';
import { RootState } from 'initializers/types';

import { HIRING_V2_SLICE_NAME } from 'features/hiringV2/constants';
import { createReducers, createSelectors } from 'features/hiringV2/helpers';
import { SendInterviewLinkPayload } from 'features/hiringV2/types/nylas';

import { INITIAL_INTERVIEWS_STATE } from './constants';
import { InterviewsState } from './types';

const SLICE_NAME = 'interviews';

const initialState = INITIAL_INTERVIEWS_STATE;

const interviewsSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: createReducers(initialState),
});

const getInterviewsState = (state: RootState) =>
  state.get(HIRING_V2_SLICE_NAME)[SLICE_NAME] as InterviewsState;

// Selectors
export const interviewsSelectors = createSelectors(
  getInterviewsState,
  initialState
);
export const interviewsActions = interviewsSlice.actions;

export const reducer = interviewsSlice.reducer;

// THUNKS
export const sendInterviewLink = createAsyncThunk(
  `${SLICE_NAME}/sendInterviewLink`,
  async (data: SendInterviewLinkPayload) => {
    try {
      const response = await postJSON(`/hiring/v2/scheduling_sessions`, data);
      return response;
    } catch (err) {
      const error = err as Error;
      throw error;
    }
  }
);
